<template>
  <div class="error-404">
    <ContentLayout/>
    <div class="content">
      <h1>{{ $t('errors.notFound') }}</h1>
      <button type="button" class="btn btn-outline-success" @click="backHome()"> {{ $t('errors.backToHomePage') }} </button>
    </div>
  </div>
</template>

<script>
import ContentLayout from 'Views/Layout/ContentLayout.vue'
export default {
  components: {
    ContentLayout
  },
  methods: {
    backHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
  .error-404 {
    .content {
      width: 100vw;
      height: 90vh;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      button {
        width: 20%;
      }
    }
  }
</style>